/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Anonymize_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Anonymize member" |
*
* @param {Member_Anonymize_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_anonymize_modal_title = /** @type {((inputs?: Member_Anonymize_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Anonymize_Modal_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anonymiser le membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anonimizar miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Anonimizar membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anonimizza membro")
	return /** @type {LocalizedString} */ ("Anonymize member")
});